import React from 'react';
import { useSearchParams } from 'react-router-dom';

function FlightSelectionViewToggle() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchType = searchParams.get('searchtype');

  const isIndividual = searchType === 'normalrt';
  const isCombined = !isIndividual;

  const handleSelectView = (type) => {
    if (type === 'individual' && !isIndividual) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('searchtype', 'normalrt');
      setSearchParams(newParams);
    } else if (type === 'combined' && !isCombined) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('searchtype', 'normal');
      setSearchParams(newParams);
    }
  };

  return (
    <div
      className="flight-selection-view-box mb-3 p-3 bg-white rounded-3 border w-100"
      style={{
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      <div
        className="fw-bold mb-2 text-dark"
        style={{ fontSize: '15px', letterSpacing: '-0.2px' }}
      >
        Flight selection view
      </div>
      <div className="d-flex gap-1 p-1 bg-light rounded-3 border w-100">
        <button
          type="button"
          onClick={() => handleSelectView('individual')}
          className="btn flex-fill py-2 px-1 fw-semibold text-center"
          style={{
            borderRadius: '6px',
            fontSize: '12px',
            lineHeight: '1.3',
            backgroundColor: isIndividual ? '#eef7ff' : 'transparent',
            color: isIndividual ? '#0084ff' : '#555555',
            border: isIndividual
              ? '1.5px solid #0084ff'
              : '1px solid transparent',
            boxShadow: isIndividual ? '0 1px 3px rgba(0,132,255,0.12)' : 'none',
            transition: 'all 0.2s ease-in-out',
            minWidth: 0,
            whiteSpace: 'nowrap',
          }}
        >
          Individual Flights
        </button>
        <button
          type="button"
          onClick={() => handleSelectView('combined')}
          className="btn flex-fill py-2 px-1 fw-semibold text-center"
          style={{
            borderRadius: '6px',
            fontSize: '12px',
            lineHeight: '1.3',
            backgroundColor: isCombined ? '#eef7ff' : 'transparent',
            color: isCombined ? '#0084ff' : '#555555',
            border: isCombined
              ? '1.5px solid #0084ff'
              : '1px solid transparent',
            boxShadow: isCombined ? '0 1px 3px rgba(0,132,255,0.12)' : 'none',
            transition: 'all 0.2s ease-in-out',
            minWidth: 0,
            whiteSpace: 'nowrap',
          }}
        >
          Combined Flights
        </button>
      </div>
    </div>
  );
}

export default FlightSelectionViewToggle;
